//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable object-curly-newline */
import { computed, ref, nextTick } from '@vue/composition-api'
import { mdiCloseBoxOutline, mdiMinusBoxOutline, mdiCheckboxBlankOutline, mdiFoodAppleOutline } from '@mdi/js'

export default {
  setup() {
    const fruits = [
      'Apples',
      'Apricots',
      'Avocado',
      'Bananas',
      'Blueberries',
      'Blackberries',
      'Boysenberries',
      'Bread fruit',
      'Cantaloupes (cantalope)',
      'Cherries',
      'Cranberries',
      'Cucumbers',
      'Currants',
      'Dates',
      'Eggplant',
      'Figs',
      'Grapes',
      'Grapefruit',
      'Guava',
      'Honeydew melons',
      'Huckleberries',
      'Kiwis',
      'Kumquat',
      'Lemons',
      'Limes',
      'Mangos',
      'Mulberries',
      'Muskmelon',
      'Nectarines',
      'Olives',
      'Oranges',
      'Papaya',
      'Peaches',
      'Pears',
      'Persimmon',
      'Pineapple',
      'Plums',
      'Pomegranate',
      'Raspberries',
      'Rose Apple',
      'Starfruit',
      'Strawberries',
      'Tangerines',
      'Tomatoes',
      'Watermelons',
      'Zucchini',
    ]
    const selectedFruits = ref([])

    const likesAllFruit = computed(() => selectedFruits.value.length === fruits.length)

    const likesSomeFruit = computed(() => selectedFruits.value.length > 0 && !likesAllFruit.value)
    const icon = computed(() => {
      if (likesAllFruit.value) return mdiCloseBoxOutline

      if (likesSomeFruit.value) return mdiMinusBoxOutline

      return mdiCheckboxBlankOutline
    })

    const toggle = () => {
      nextTick(() => {
        if (likesAllFruit.value) {
          selectedFruits.value = []
        } else {
          selectedFruits.value = fruits.slice()
        }
      })
    }

    return {
      fruits,
      selectedFruits,
      likesAllFruit,
      likesSomeFruit,
      icon,
      toggle,

      // icons
      icons: {
        mdiFoodAppleOutline,
      },
    }
  },
}
